import request from '@/utils/request'
import utils from '@/utils/utils';

/** 获取开发者帮助 */
export const getDevHelp = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "help.querypage",
      url:'/help/querypage',
      data: {
        "userName": JSON.parse(utils.getCookie("USER_INFO")),
        "token": utils.getCookie("TOKEN"),
        "pageNo":self.page,
        "pageSize":self.pageSize
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        self.$message.error(res.message)
      }
    })
  })
}

/** 申请/修改 开发者帮助 */
export const subDevHelp = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "help.submithelp",
      url:'/help/submithelp',
      data: {
        "userName": JSON.parse(utils.getCookie("USER_INFO")),
        "token": utils.getCookie("TOKEN"),
        "helpId":self.helpId,
        "helpSubject":self.helpId,
        "helpContent":self.helpId,
        "mobile":self.helpId,
        "email":self.helpId,
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        self.$message.error(res.message)
      }
    })
  })
}

/** 获取 常见问题 菜单 */
export const getCommonHelpMenu = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "normalquestion.menus",
      url:'/normalquestion/menus',
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        self.$message.error(res.message)
      }
    })
  })
}

/** 获取 常见问题 详情 */
export const getCommonHelpDetails = (self,id) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "normalquestion.docmd",
      url:'/normalquestion/docmd',
      data:{
        "docId":id
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        self.$message.error(res.message)
      }
    })
  })
}


